import React from 'react';
import Modal from 'react-bootstrap/Modal';

import ArcadiaIFrame from '../../../components/UtilityImportSettings/ArcadiaIFrame';

const plug_iframe_key = 'h9PCGEYwX64Ly0SyF3qs';

function NewProviderModal(props) {
  const { show, onHide, organizationId } = props;

  return (
    <Modal size='lg' show={show} onHide={onHide} centered>
      <ArcadiaIFrame
        organizationId={organizationId}
        iframe_key={plug_iframe_key}
      />

    </Modal>
  );
}

export default NewProviderModal;
